import { ConsoleSqlOutlined } from '@ant-design/icons';

/**
 * Extracts typeOfIoC from exploreData
 * @param exploreData
 * @param typeOfIoC
 */
export function extractDomainIoCsFromExploreData({
  exploreData,
  typeOfIoC,
  queryType,
}) {
  if (typeOfIoC === 'domain') {
    return extractDomainsFromExploreData(exploreData, queryType);
  } else if (typeOfIoC === 'IP') {
    return extractIPsFromExploreData(exploreData);
  }
  return [];
}

/**
 * Extracts typeOfIoC from exploreData
 * @param exploreData
 * @param typeOfIoC
 */
export function extractIPIoCsFromExploreData({
  exploreData,
  typeOfIoC,
  queryType,
}) {
  if (typeOfIoC === 'domain') {
    return extractDomainsFromExploreData(exploreData, queryType);
  } else if (typeOfIoC === 'IP') {
    return extractIPsFromExploreData(exploreData, queryType);
  }
  return [];
}

function extractIPsFromExploreData(exploreData, queryType) {
  const data = exploreData ?? [];
  const IPs = data
    .map((elem) => {
      if (elem?.query?.includes(':') || elem?.answer?.includes(':')) {
        return;
      }
      if (elem.type === 'PTR') {
        return elem.query;
      } else if (elem.type === 'A') {
        return elem.answer;
      }
      if (queryType === 'ssdeep') {
        return elem?.ip;
      }
    })
    .filter((x) => x !== '' && x !== null && x !== false && x !== undefined);
  return IPs;
}

function extractDomainsFromExploreData(exploreData, queryType) {
  const data = exploreData ?? [];
  const domains = data.map((elem) => {
    // eslint-disable-next-line default-case
    switch (queryType) {
      case 'any':
        if (elem.type === 'PTR') {
          return elem.answer;
        } else if (elem.type === 'A') {
          return elem.query;
        } else if (elem.type === 'AAAA') {
          return elem.query;
        } else if (elem.type === 'NS') {
          return elem.answer;
        } else if (elem.type === 'MX') {
          return elem.answer;
        } else if (elem.type === 'CNAME') {
          return elem.answer;
        } else if (elem.type === 'TXT') {
          return elem.query;
        } else if (elem.type === 'SOA') {
          return elem.query;
        }
        break;
      case 'anyIP':
        if (elem.type === 'PTR') {
          return elem.answer;
        } else if (elem.type === 'A') {
          return elem.query;
        }
        break;
      case 'ANYIPV4':
        if (elem.type === 'PTR') {
          return elem.answer;
        } else if (elem.type === 'A') {
          return elem.query;
        }
        break;
      case 'ANYIPV6':
        if (elem.type === 'PTR') {
          return elem.answer;
        } else if (elem.type === 'A') {
          return elem.query;
        } else if (elem.type === 'AAAA') {
          return elem.query;
        }
        break;
      case 'NS': {
        return elem.query;
      }
      case 'MX': {
        return elem.query;
      }
      case 'A': {
        return elem.query;
      }
      case 'PTR': {
        return elem.answer;
      }
      case 'PTR4': {
        return elem.answer;
      }
      case 'PTR6': {
        return elem.answer;
      }
      case 'AAAA': {
        return elem.query;
      }
      case 'CNAME': {
        return elem.answer;
      }
      case 'TXT': {
        return elem.query;
      }
      case 'SOA': {
        return elem.query;
      }
      case 'historyQueryResults':
        if (elem?.type === 'NS') {
          return elem.query;
        }
      default:
        if (elem.type === 'PTR') {
          return elem.answer;
        } else if (elem.type === 'A') {
          return elem.query;
        } else if (elem.type === 'AAAA') {
          return elem.query;
        } else if (elem.type === 'NS') {
          return elem.answer;
        } else if (elem.type === 'MX') {
          return elem.answer;
        } else if (elem.type === 'CNAME') {
          return elem.answer;
        } else if (elem.type === 'TXT') {
          return elem.query;
        } else if (elem.type === 'SOA') {
          return elem.query;
        }
        break;
    }
  });

  return domains;
}
